import { AppEnvironments } from "constants/app_environments";

const RUM_ENV = process.env.REACT_APP_RUM_ENV || AppEnvironments.Development;
const isProduction =
  RUM_ENV === AppEnvironments.Production ||
  RUM_ENV === AppEnvironments.ProductionUs ||
  RUM_ENV === AppEnvironments.ProductionFedRAMP;

export const withTestId = (id?: string) => (id && !isProduction ? { "data-testid": id } : null);
